import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import SyncConstants from "../../constants/SyncConstants";
import { copy } from "../../libs/SlotUtils";
import PersonLabelWithDynamicInfo from "../Team/PersonLabelWithDynamicInfo";
import MinutesToTime from "./MinutesToTime";
import ConfirmButton from "./ConfirmButton";
import moment from "moment";
import stylelist from "stylelist";
import { Activities } from "../../constants/ExpenseConstants";
import { add_entry } from "../../actions/ExpenseBucket";
import ExpenseMask from "../Slots/ExpenseMask";
import SlideToConfirm from "../UI/SlideToConfirm";
import useAuthentication from "../../hooks/useAuthentication";
import { generateRandomClassName, generateRandomTiming } from "../../libs/StringUtil";
import { set_notification } from "../../actions/Sync";

const ExpenseEntryList = (props) => {

    const UserSettings = useSelector((state) => state.User);
    const ExpenseBucket = useSelector((state) => state.ExpenseBucket);
    const [serverData, setServerData] = useState({});
    const [showChildrenIds, setShowChildrenIds] = useState([]);
    const [showFullBreadcrumb, setShowFullBreadcrumb] = useState(false);
    const [showBookedBy, setShowBookedBy] = useState(true);
    const [expandedComments, setExpandedComments] = useState([]);
    const [expandAllComments, setExpandAllComments] = useState(false);
    const [showNewExpenseMask, setShowNewExpenseMask] = useState(false);
    const [showUpdateMask, setShowUpdateMask] = useState(false);
    const [updateEntry, setUpdateEntry] = useState({});
    const [randomClassName, setRandomClassName] = useState(generateRandomClassName());
    const [isLoading, setIsLoading] = useState(false);
    const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
    const [entryToDelete, setEntryToDelete] = useState(null);
    const [deleteCount, setDeleteCount] = useState(0);
    const [skipSliderForSession, setSkipSliderForSession] = useState(false);
    const Auth = useAuthentication();
    const dispatch = useDispatch();
    const history = useHistory();

    // Beim Starten: Aktionen ausführen
    const init = useEffect(() => {
        loadFromServer();
    }, []);

    useEffect(() => {
        loadFromServer();
    }, [props.filterDateFrom, props.filterDateTo, props.filterPerson]);

    const addAllToBucket = () => {
        Object.values(serverData.entries).forEach(entry => {
            if (entry.accounted != 1) {
                dispatch(add_entry(entry));
            }
        });
    }

    const loadFromServer = () => {
        setIsLoading(true);
        axios({
            method: "get",
            auth: Auth.getAuthObject(),
            url: SyncConstants["syncBaseURL"] + "expenseEntries/byProject",
            params: {
                project: props.project,
                filter: {
                    dateFrom: props.filterDateFrom,
                    dateTo: props.filterDateTo,
                    person: props.filterPerson
                }
            },
            responseType: 'json'
        }).then((response) => {
            setServerData(response.data);
            setIsLoading(false);
        }).catch(response => {
            setIsLoading(false);
        });
    }

    const deleteEntry = (entryId) => {
        axios({
            method: "delete",
            auth: Auth.getAuthObject(),
            url: SyncConstants["syncBaseURL"] + "expenseEntry",
            responseType: 'json',
            data: { entryId: entryId }
        }).then((response) => {
            loadFromServer();
            dispatch(set_notification("Erfolgreich gelöscht", "success"));
            setDeleteCount(prev => prev + 1);
        }).catch(response => {
            dispatch(set_notification("Eintrag konnte nicht gelöscht werden (Fehler vom Server gemeldet)", "error"));
        });
    }

    let currentDate;
    let isNewDate;
    return <>
        <SlideToConfirm
            show={showDeleteConfirm}
            onConfirm={() => {
                deleteEntry(entryToDelete);
                setShowDeleteConfirm(false);
                setEntryToDelete(null);
            }}
            onCancel={() => {
                setShowDeleteConfirm(false);
                setEntryToDelete(null);
            }}
            title="Eintrag löschen"
            message="Möchten Sie diesen Aufwandseintrag wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden."
            slideText="Zum Löschen schieben"
            variant="danger"
            showBulkDeleteOption={deleteCount >= 1}
            onBulkDeleteToggle={(skip) => setSkipSliderForSession(skip)}
        />

        {isLoading && (
            <div className="d-flex justify-content-center align-items-center p-5">
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Laden...</span>
                </div>
            </div>
        )}

        {!isLoading && serverData.entries !== undefined &&
            <>

                {showUpdateMask && ReactDOM.createPortal(
                    <div
                        className={stylelist("overlay d-flex justify-content-center align-items-center", randomClassName)}
                        style={{
                            position: 'fixed',
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            zIndex: 9999,
                            backgroundColor: 'rgba(0,0,0,0.5)'
                        }}
                        onClick={(e) => {
                            if (e.target === e.currentTarget) {
                                setShowUpdateMask(false);
                            }
                        }}
                    >
                        <div className="modal d-block">
                            <div className="modal-dialog" style={{ minWidth: "1024px" }}>
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <h5 className="modal-title">Einen Aufwand bearbeiten</h5>
                                        <button type="button" className="btn-close" onClick={() => { setShowUpdateMask(false) }} aria-label="Close"></button>
                                    </div>
                                    <div className="modal-body">
                                        <ExpenseMask update={true} updateEntry={updateEntry} afterSubmit={(needDeepUpdate) => {
                                            setShowUpdateMask(false);
                                            setUpdateEntry({});
                                            loadFromServer();
                                        }} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>,
                    document.body
                )}

                <div className=" p-0">

                    {showNewExpenseMask &&
                        <>

                        </>
                    }

                    {Object.values(serverData.entries).length > 0 &&
                        <>
                            <div className="card border-0 shadow-sm">
                                <div className="card-body p-0">
                                    <div className="table-responsive">
                                        <table className="table table-hover table-striped mb-0 align-middle" style={{fontSize: '0.875rem'}}>
                                            <thead className="bg-light border-bottom" style={{position: 'sticky', top: 0, zIndex: 10}}>
                                                <tr>
                                                    <th className="py-2 px-3 text-muted fw-semibold" style={{width: '110px', fontSize: '0.8rem'}}>
                                                        <div className="d-flex align-items-center">
                                                            <i className="bi bi-calendar3 me-1"></i>
                                                            <span className="text-nowrap">Datum</span>
                                                        </div>
                                                    </th>
                                                    <th className="py-2 px-3 text-muted fw-semibold" style={{width: '180px', fontSize: '0.8rem', position: 'relative'}}>
                                                        <div className="d-flex align-items-center">
                                                            <i className="bi bi-person me-2"></i>
                                                            <span>Person</span>
                                                        </div>
                                                        <button
                                                            className={`btn btn-sm p-1 ${showBookedBy ? 'btn-outline-secondary' : 'btn-secondary'}`}
                                                            style={{fontSize: '0.7rem', lineHeight: 1, position: 'absolute', right: '12px', top: '50%', transform: 'translateY(-50%)'}}
                                                            onClick={() => setShowBookedBy(!showBookedBy)}
                                                            title={showBookedBy ? "Gebucht von ausblenden" : "Gebucht von einblenden"}
                                                        >
                                                            <i className={`bi bi-${showBookedBy ? 'eye-slash' : 'eye'}`}></i>
                                                        </button>
                                                    </th>
                                                    {props.expandView && (
                                                        <th className="py-2 px-3 text-muted fw-semibold" style={{width: '100px', fontSize: '0.8rem'}}>
                                                            <div className="d-flex align-items-center">
                                                                <i className="bi bi-hash me-1"></i>
                                                                <span className="text-nowrap">Slot</span>
                                                            </div>
                                                        </th>
                                                    )}
                                                    <th className="py-2 px-3 text-muted fw-semibold" style={{fontSize: '0.8rem', position: 'relative'}}>
                                                        <div className="d-flex align-items-center">
                                                            <i className="bi bi-chat-left-text me-1"></i>
                                                            <span className="text-nowrap">Kommentar</span>
                                                        </div>
                                                        <button
                                                            className={`btn btn-sm p-1 ${expandAllComments ? 'btn-secondary' : 'btn-outline-secondary'}`}
                                                            style={{fontSize: '0.7rem', lineHeight: 1, position: 'absolute', right: '12px', top: '50%', transform: 'translateY(-50%)'}}
                                                            onClick={() => {
                                                                setExpandAllComments(!expandAllComments);
                                                                if (!expandAllComments) {
                                                                    // Alle Kommentare aufklappen
                                                                    const allIds = Object.values(serverData.entries).map(e => e.id);
                                                                    setExpandedComments(allIds);
                                                                } else {
                                                                    // Alle zuklappen
                                                                    setExpandedComments([]);
                                                                }
                                                            }}
                                                            title={expandAllComments ? "Alle Kommentare einklappen" : "Alle Kommentare ausklappen"}
                                                        >
                                                            <i className={`bi bi-${expandAllComments ? 'chevron-compact-up' : 'chevron-compact-down'}`}></i>
                                                        </button>
                                                    </th>
                                                    <th className="py-2 px-3 text-center text-muted fw-semibold" style={{width: '100px', fontSize: '0.8rem'}}>
                                                        <div className="d-flex align-items-center justify-content-center">
                                                            <i className="bi bi-clock me-1"></i>
                                                            <span className="text-nowrap">Aufwand</span>
                                                        </div>
                                                    </th>
                                                    <th className="py-2 px-3 text-muted fw-semibold" style={{width: '280px', fontSize: '0.8rem'}}>
                                                        <div className="d-flex align-items-center">
                                                            <i className="bi bi-list-task me-2"></i>
                                                            Tätigkeit
                                                            <button
                                                                className="btn btn-link btn-sm p-0 ms-2 text-muted"
                                                                onClick={() => setShowFullBreadcrumb(!showFullBreadcrumb)}
                                                                title={showFullBreadcrumb ? "Vollständigen Pfad ausblenden" : "Vollständigen Pfad anzeigen"}
                                                            >
                                                                <i className={`bi bi-${showFullBreadcrumb ? 'chevron-compact-up' : 'chevron-compact-down'}`}></i>
                                                            </button>
                                                        </div>
                                                    </th>

                                                    {!props.expenseBucket ? (
                                                        <th className="py-2 px-3 text-center text-muted fw-semibold" style={{width: '140px', fontSize: '0.8rem'}}>
                                                            <div className="d-flex align-items-center justify-content-center">
                                                                <i className="bi bi-gear me-1"></i>
                                                                <span className="text-nowrap">Aktionen</span>
                                                            </div>
                                                        </th>
                                                    ) : (
                                                        <th 
                                                            className="py-2 px-3 text-center text-muted fw-semibold" 
                                                            style={{width: '140px', fontSize: '0.8rem'}}
                                                        >
                                                            <button
                                                                className="btn btn-sm btn-outline-primary"
                                                                onClick={() => addAllToBucket()}
                                                                title="Alle in Bucket verschieben"
                                                            >
                                                                <i className="bi bi-box-arrow-in-down me-1"></i>
                                                                Alle
                                                            </button>
                                                        </th>
                                                    )}
                                                </tr>
                                            </thead>

                                            <tbody>
                                                <>
                                                    {currentDate = ""}
                                                    {isNewDate = false}

                                                    {Object.values(serverData.entries).sort((a, b) => {
                                                        // First sort by date (descending)
                                                        const dateCompare = b.date.toString().localeCompare(a.date);
                                                        if (dateCompare !== 0) {
                                                            return dateCompare;
                                                        }
                                                        // If dates are equal, sort by ID (descending - newest first)
                                                        return b.id - a.id;
                                                    }).map(iteration => {

                                                        if (currentDate != iteration.date) {
                                                            isNewDate = true;
                                                            currentDate = iteration.date;
                                                        } else {
                                                            isNewDate = false;
                                                        }

                                                        return <React.Fragment key={iteration.id}>

                                                            {Boolean(isNewDate && props.separateByDays) &&
                                                                <tr className="bg-light">
                                                                    <td colSpan="7" className="text-center py-2 fw-bold text-primary border-top border-bottom">
                                                                        <i className="bi bi-calendar-event me-2"></i>
                                                                        {moment(iteration.date).format("dddd, DD. MMMM YYYY")}
                                                                    </td>
                                                                </tr>
                                                            }

                                                            <tr 
                                                                className={stylelist(
                                                                    "border-bottom",
                                                                    [ExpenseBucket.addedIds.indexOf(iteration.id) > -1, "text-decoration-line-through"],
                                                                    [iteration.accounted == 1, "opacity-50"]
                                                                )}
                                                                style={{transition: 'background-color 0.2s'}}
                                                            >
                                                                <td className="px-3 py-2">
                                                                    <span className="badge bg-light text-dark border">
                                                                        {moment(iteration.date).format("DD.MM.YY")}
                                                                    </span>
                                                                </td>

                                                                <td className="px-3 py-2">
                                                                    <PersonLabelWithDynamicInfo name={iteration.person} />
                                                                    {showBookedBy && iteration.booked_by && (
                                                                        <div className="text-muted small mt-1">
                                                                            <i className="bi bi-arrow-return-right me-1"></i>
                                                                            von <PersonLabelWithDynamicInfo name={iteration.booked_by} />
                                                                        </div>
                                                                    )}
                                                                </td>

                                                                {props.expandView && (
                                                                    <td className="px-3 py-2">
                                                                        <span className="badge bg-secondary">{iteration.slot_id}</span>
                                                                    </td>
                                                                )}

                                                                <td className="px-3 py-2">
                                                                    <div style={{
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        maxWidth: '400px'
                                                                    }}>
                                                                        <span style={{
                                                                            overflow: 'hidden',
                                                                            textOverflow: 'ellipsis',
                                                                            whiteSpace: expandAllComments ? 'normal' : 'nowrap',
                                                                            flex: 1
                                                                        }}>
                                                                            {iteration.comment}
                                                                        </span>
                                                                        {iteration.comment && iteration.comment.length > 50 && !expandAllComments && (
                                                                            <i 
                                                                                className="bi bi-chat-left-dots text-primary ms-2 cursor-pointer"
                                                                                style={{flexShrink: 0}}
                                                                                onClick={() => {
                                                                                    if (expandedComments.includes(iteration.id)) {
                                                                                        setExpandedComments(expandedComments.filter(id => id !== iteration.id));
                                                                                    } else {
                                                                                        setExpandedComments([...expandedComments, iteration.id]);
                                                                                    }
                                                                                }}
                                                                                title={expandedComments.includes(iteration.id) ? "Einklappen" : "Vollständig anzeigen"}
                                                                            ></i>
                                                                        )}
                                                                    </div>
                                                                    {expandedComments.includes(iteration.id) && !expandAllComments && (
                                                                        <div className="mt-2 p-2 bg-light rounded small">
                                                                            {iteration.comment}
                                                                        </div>
                                                                    )}
                                                                </td>

                                                                <td className="px-3 py-2 text-center">
                                                                    <MinutesToTime minutes={iteration.minutes} />
                                                                    {Boolean(iteration.accounted == 1 && iteration.accounted_invoice_id) && (
                                                                        <div className="mt-1">
                                                                            <span
                                                                                className="badge bg-success cursor-pointer"
                                                                                onClick={() => { history.push(`/invoices/${iteration.accounted_invoice_id}`); }}
                                                                                title="Zur Rechnung"
                                                                            >
                                                                                <i className="bi bi-receipt me-1"></i>
                                                                                #{iteration.accounted_invoice_id}
                                                                            </span>
                                                                        </div>
                                                                    )}
                                                                </td>

                                                                <td className="px-3 py-2">
                                                                    <div className="d-flex flex-column">
                                                                        <small className="text-muted">
                                                                            <i className="bi bi-folder me-1"></i>
                                                                            {showFullBreadcrumb ? iteration.breadcrumb : (iteration.project_title).substr(0, 50)}
                                                                            {!showFullBreadcrumb && iteration.project_title.length > 50 && '...'}
                                                                        </small>
                                                                        {iteration.activity && (
                                                                            <small className="text-secondary mt-1" style={{fontStyle: 'italic'}}>
                                                                                → {Activities[iteration.activity]}
                                                                            </small>
                                                                        )}
                                                                    </div>
                                                                </td>

                                                                <td className="px-3 py-2 text-center">
                                                                    {!props.expenseBucket ? (
                                                                        <div className="btn-group btn-group-sm" role="group">
                                                                            <button
                                                                                className="btn btn-outline-primary"
                                                                                onClick={() => { setUpdateEntry(iteration); setShowUpdateMask(true) }}
                                                                                title="Bearbeiten"
                                                                            >
                                                                                <i className="bi bi-pencil-square"></i>
                                                                            </button>
                                                                            <button
                                                                                className="btn btn-outline-danger"
                                                                                onClick={() => {
                                                                                    if (skipSliderForSession) {
                                                                                        // Direkt löschen ohne Dialog
                                                                                        deleteEntry(iteration.id);
                                                                                    } else {
                                                                                        // Dialog anzeigen
                                                                                        setEntryToDelete(iteration.id);
                                                                                        setShowDeleteConfirm(true);
                                                                                    }
                                                                                }}
                                                                                title="Löschen"
                                                                            >
                                                                                <i className="bi bi-trash"></i>
                                                                            </button>
                                                                        </div>
                                                                    ) : (
                                                                        <>
                                                                            {Boolean(ExpenseBucket.addedIds.indexOf(iteration.id) < 0 && iteration.accounted != 1) && (
                                                                                <button
                                                                                    className="btn btn-sm btn-success"
                                                                                    onClick={() => { dispatch(add_entry(iteration)) }}
                                                                                    title="Abrechnen"
                                                                                >
                                                                                    <i className="bi bi-plus-circle me-1"></i>
                                                                                    Abrechnen
                                                                                </button>
                                                                            )}
                                                                        </>
                                                                    )}
                                                                </td>
                                                            </tr>
                                                        </React.Fragment>
                                                    })}
                                                </>

                                                <tr className="bg-light border-top-2">
                                                    <td className="px-3 py-2 fw-bold">Gesamt</td>
                                                    <td className="px-3 py-2"></td>
                                                    {props.expandView && <td className="px-3 py-2"></td>}
                                                    <td className="px-3 py-2"></td>
                                                    <td className="px-3 py-2 text-center fw-bold">
                                                        <MinutesToTime minutes={serverData.calculation.total} />
                                                    </td>
                                                    <td className="px-3 py-2"></td>
                                                    <td className="px-3 py-2"></td>
                                                </tr>

                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </>
                    }

                    {Object.values(serverData.entries).length < 1 &&
                        <div className="card border-0 shadow-sm">
                            <div className="card-body text-center py-5">
                                <i className="bi bi-inbox display-1 text-muted mb-3"></i>
                                <h5 className="text-muted">Keine Buchungen gefunden</h5>
                                <p className="text-muted">Mit den gewählten Filtern sind keine Einträge vorhanden.</p>
                            </div>
                        </div>
                    }
                </div>
            </>
        }
    </>
}

export default ExpenseEntryList;